import React from 'react';
import classNames from 'classnames';

import propTypes from 'propTypes';
import PasswordInput from 'common/components/PasswordInput';

const Input = ({
  component,
  disabled,
  input,
  label,
  meta: { active, dirty, touched, error, warning },
  className,
  ...props
}) => {
  const Component = component;
  return (
    <div>
      <Component
        disabled={disabled}
        className={classNames(className, 'Field__input', {
          'Field__input--disabled': disabled,
        })}
        placeholder={active ? '' : label}
        {...input}
        {...props}
      />
      {touched &&
        ((error && <div className="Field__error">{error}</div>) ||
          (warning && <div className="Field__warning">{warning}</div>))}
    </div>
  );
};

Input.Password = props => <Input component={PasswordInput} {...props} />;

Input.propTypes = {
  component: propTypes.oneOfType([propTypes.func, propTypes.string]),
  disabled: propTypes.bool,
  input: propTypes.object.isRequired,
  label: propTypes.string,
  meta: propTypes.FormMeta.isRequired,
};

Input.defaultProps = {
  component: 'input',
};

export default Input;



// WEBPACK FOOTER //
// ./app/javascript/common/components/Form/Input.js